import React, { Component } from 'react';
import classes from './YearMonthPicker.module.css';
import Spinner from 'components/UI/Spinner/Spinner';

class YearMonthPicker extends Component {
  constructor(props) {
    super(props);
    this.state = {
      years: [],
      initiallyLoadedPostCount: 2100,
      initialYear: this.props.selectedYear ? this.props.selectedYear : this.props.defaultYear,
      monthAbbreviations: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      scrollSet: false,
      loading: true,
    };
    this.scrollContainer = React.createRef();
  }

  componentDidMount() {
    // This selector is designed to load all years when the component loads rather than using infinite scroll to load more years.
    // The reason for this is that Safari scrolls to top of scroll container when years are appended to the top of the years list
    // during infinite scroll
    const initialYear = this.props.selectedYear ? this.props.selectedYear : this.props.defaultYear;
    const startingYear = this.props.dateRangeStart
      ? this.props.dateRangeStart
      : this.props.totalDateRangeYears
      ? new Date().getFullYear() - (this.props.totalDateRangeYears - 25)
      : 0;
    const years = Array.from(
      Array(this.props.totalDateRangeYears ? this.props.totalDateRangeYears : this.state.initiallyLoadedPostCount),
      (_, i) => startingYear + i,
    );
    this.setState({ initialYear, years });
  }

  handleMonthSelect = (month, year) => {
    const monthNumber = this.state.monthAbbreviations.indexOf(month) + 1;
    const date = `${monthNumber}/0/${year}`;
    this.props.handleDateSelection(date, this.props.activeDate);
    this.props.close();
  };

  addPreviousYears = () => {
    const updatedYears = Array.from(Array(20), (_, i) => this.state.years[0] - 20 + i).concat(this.state.years);
    this.setState({ years: updatedYears });
  };

  addFutureYears = () => {
    const additionalYears = Array.from(Array(20), (_, i) => this.state.years[this.state.years.length - 1] + 1 + i);
    const updatedYears = this.state.years.concat(additionalYears);
    this.setState({ years: updatedYears });
  };

  listenScrollEvent = () => {
    if (this.state.scrollSet) {
      if (this.scrollContainer.current.scrollTop < 800) {
        this.addPreviousYears();
      } else if (this.scrollContainer.current.scrollTop > this.scrollContainer.current.scrollHeight - 1000) {
        this.addFutureYears();
      }
    } else {
      this.setState({ scrollSet: true });
    }
  };

  render = () => {
    let yearList = null;
    const containerClasses = [classes.Container];
    if (this.props.type) containerClasses.push(classes[this.props.type]);

    function waitForSelectedYearElement(id, index, scrollSet, formType, callback) {
      const foo = setInterval(() => {
        if (document.getElementById(id)) {
          clearInterval(foo);
          if (!scrollSet) callback(index, formType);
        }
      }, 100);
    }

    waitForSelectedYearElement(
      `element-${this.state.initialYear}`,
      this.state.initialYear,
      this.state.scrollSet,
      this.props.type,
      (index, formType) => {
        const focusedYearElement = document.getElementById(`element-${index}`);
        focusedYearElement.parentNode.scrollTop = focusedYearElement.offsetTop - (formType === 'ProfileForm' ? 400 : 460);
      },
    );

    if (this.state.years.length > 0) {
      yearList = this.state.years.map((year) => {
        let yearClasses = [classes.Year];
        const yearIsDisabled = (this.props.minYear && this.props.minYear > year) || (this.props.maxYear && this.props.maxYear < year);
        if (this.props.defaultYear === year) yearClasses.push(classes.Default);
        if (yearIsDisabled) yearClasses.push(classes.Disabled);
        if (this.props.selectedYear === year) yearClasses = [classes.Year, classes.Selected];

        return (
          <div className={classes.ListItem} key={year} id={`element-${year}`}>
            <div
              className={yearClasses.join(' ')}
              onClick={yearIsDisabled ? null : () => this.props.handleDateSelection(`0/0/${year}`, this.props.activeDate)}
            >
              <span>{year}</span>
            </div>
            <div className={classes.Months}>
              {this.state.monthAbbreviations.map((month, i) => {
                const monthIsDisabled =
                  yearIsDisabled ||
                  (this.props.minYear === year && this.props.minMonth > i + 1) ||
                  (this.props.maxYear === year && this.props.maxMonth < i + 1);
                return (
                  <span
                    key={`${year}-${month}`}
                    onClick={monthIsDisabled ? null : () => this.handleMonthSelect(month, year)}
                    className={
                      monthIsDisabled
                        ? [classes.Disabled, classes.Month].join(' ')
                        : this.props.selectedMonth === i + 1 && this.props.selectedYear === year
                        ? [classes.Month, classes.Selected].join(' ')
                        : this.props.defaultMonth === i + 1 && this.props.defaultYear === year
                        ? [classes.Month, classes.Default].join(' ')
                        : classes.Month
                    }
                  >
                    {month}
                  </span>
                );
              })}
            </div>
          </div>
        );
      });

      if (this.state.loading) this.setState({ loading: false });
    }

    return (
      <div className={containerClasses.join(' ')}>
        {this.state.loading || !this.state.scrollSet ? (
          <div className={classes.SpinnerContainer}>
            <Spinner small />
          </div>
        ) : null}
        {!this.state.loading ? (
          <div
            style={{ visibility: !this.state.scrollSet ? 'hidden' : 'visible' }}
            ref={this.scrollContainer}
            onScroll={this.listenScrollEvent.bind(this)}
            className={classes.ScrollContainer}
          >
            {yearList}
          </div>
        ) : null}
      </div>
    );
  };
}

export default YearMonthPicker;
